import { warehouseIdsKey } from "../analyticsWarehouses";

/**
 * In-memory cache key for a clicked-day SKU result.
 * Must include every filter that changes Path A totals.
 */
export const buildDailySkuCacheKey = (
  clientId,
  salesDay,
  sourceChannels = [],
  warehouseIds = [],
) => {
  const sources = [...(sourceChannels || [])]
    .filter((value) => value != null && value !== "")
    .map(String)
    .sort();
  // Sorted, deduplicated warehouse set ("" = All warehouses), so the same
  // selection in any order maps to one entry.
  const warehouses = warehouseIdsKey(
    Array.isArray(warehouseIds) ? warehouseIds : [warehouseIds],
  );
  return `${clientId || ""}|${salesDay || ""}|${sources.join("\u0000")}|${warehouses}`;
};
